import Button from "../CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import React from "react";

const button = props => (
  <Button {...props} icon wd bsStyle="primary">
    {/* <i className="fa fa-lg fa-cloud margin-right-5" /> */}
    <i className="fa fa-lg fa-plus-circle margin-right-5" />
    <FormattedMessage id={props.ids} />
  </Button>
);

export default button;
